import axios from 'axios'
import config from '@/helpers/config'
import store from '@/store'

const state = {
  roles: [],
  plans: []
}

const mutations = {
  setRoles (state, payload) {
    state.roles = payload
  },
  setPlans (state, payload) {
    state.plans = payload
  }
}

const getters = {
  getRoles (state) {
    return state.roles
  },
  getRoleByName (state) {
    return name => state.roles.filter(item => { return item.name === name })
  },
  getSubscriptionPlans (state) {
    return state.plans.filter(item => { return item.type === 'SUBSCRIPTION' && item.isVisible })
  },
  getDiyPlans (state) {
    return state.plans.filter(item => { return item.type === 'DIY' && item.isVisible })
  },
  getPlanById (state) {
    return id => state.plans.filter(item => { return item.id === id })
  },
  getPlanByUuid (state) {
    return uuid => state.plans.filter(item => { return item.uuid === uuid })
  }
}

const actions = {
  getOrganizationsWithAll (context, payload) {
    return axios.get(
      config.apiUrl + '/organizations/with-all?no_cache=' + (new Date()).getTime(),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  deleteOrganization (context, payload) {
    return axios.delete(
      config.apiUrl + '/organizations/' + payload.id,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getOrganizationsUsersWithAll (context, payload) {
    return axios.get(
      config.apiUrl + '/organizations-users/with-all?no_cache=' + (new Date()).getTime(),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  deleteOrganizationUser (context, payload) {
    return axios.delete(
      config.apiUrl + '/organizations-user/' + payload.organizationId + '/' + payload.userId,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getOrganizationsProjectsWithAll (context, payload) {
    return axios.get(
      config.apiUrl + '/organizations-projects/with-all?no_cache=' + (new Date()).getTime(),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  deleteOrganizationProject (context, payload) {
    return axios.delete(
      config.apiUrl + '/organizations-projects/' + payload.organizationId + '/' + payload.projectId,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getOrganizationsUsersProjectsWithAll (context, payload) {
    return axios.get(
      config.apiUrl + '/organizations-users-projects/with-all?no_cache=' + (new Date()).getTime(),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  deleteOrganizationUserProject (context, payload) {
    return axios.delete(
      config.apiUrl + '/organizations-users-projects/' + payload.organizationId + '/' + payload.userId + '/' + payload.projectId,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getProjectsWithAll (context, payload) {
    return axios.get(
      config.apiUrl + '/projects/with-all?no_cache=' + (new Date()).getTime(),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  deleteProject (context, payload) {
    return axios.delete(
      config.apiUrl + '/projects/' + payload.id,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getProjectsPlansWithAll (context, payload) {
    return axios.get(
      config.apiUrl + '/projects-plans/with-all?no_cache=' + (new Date()).getTime(),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  deleteProjectPlan (context, payload) {
    return axios.delete(
      config.apiUrl + '/projects-plans/' + payload.projectId + '/' + payload.planId,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getUsersWithAll (context, payload) {
    return axios.get(
      config.apiUrl + '/users/with-all?no_cache=' + (new Date()).getTime(),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  deleteUser (context, payload) {
    return axios.delete(
      config.apiUrl + '/users/' + payload.id,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getRolesWithAll (context, payload) {
    return axios.get(
      config.apiUrl + '/roles/with-all?no_cache=' + (new Date()).getTime(),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  deleteRole (context, payload) {
    return axios.delete(
      config.apiUrl + '/roles/' + payload.id,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getRolesPrivilegesWithAll (context, payload) {
    return axios.get(
      config.apiUrl + '/roles-privileges/with-all?no_cache=' + (new Date()).getTime(),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  deleteRolePrivilege (context, payload) {
    return axios.delete(
      config.apiUrl + '/roles-privileges/' + payload.roleId + '/' + payload.privilegeId,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getPrivileges (context, payload) {
    return axios.get(
      config.apiUrl + '/privileges?no_cache=' + (new Date()).getTime(),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  deletePrivilege (context, payload) {
    return axios.delete(
      config.apiUrl + '/privileges/' + payload.id,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getPlans (context, payload) {
    return axios.get(
      config.apiUrl + '/plans?no_cache=' + (new Date()).getTime(),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  deletePlan (context, payload) {
    return axios.delete(
      config.apiUrl + '/plans/' + payload.id,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/admin.js